import api from '@/api/user'
import { getUser, setUser, setUserId, clearAuth, setToken } from '@/utils/auth'
const state = {
  userInfo: getUser() || {},
  menuList: [{
    name: '首页',
    key: 'home'
  }, {
    name: '阅读页',
    key: 'book'
  }, {
    name: '文献',
    key: 'literature'
  }, {
    name: '图书信息',
    key: 'detail'
  }, {
    name: '我的收藏',
    key: 'collection'
  }],
  library: {
    // 'id': '805464a8-5ab5-48c4-84c8-207a9b2d497a',
    // 'name': '山东馆',
    // 'code': '0001',
    // 'location': '山东省济南市',
    // 'createdAt': 1723191485902,
    // 'updatedAt': 1723603727365,
    // 'bookFilePath': 'https://bookviewstorage.oss-cn-beijing-internal.aliyuncs.com',
    // 'webUrlName': 'shandong',
    // 'docType': 'single',
    // 'txtShow': 1
  }
}
const actions = {
  async logOut ({ commit }) {
    return commit('removeUserInfo')
  },
  async login ({ commit }, payload) {
    let res = await api.login(payload)
    if (res.code === 200) {
      commit('setUserInfo', res.data)
      return res.data
    } else {
      return res
    };
  },
  async getLibrary ({ commit }) {
    let res = await api.getLibraries()
    let list = res.rows
    let pathname = window.location.pathname
    for (let item of list) {
      if (pathname.includes(`/ancient-${item.webUrlName}/`)) {
        document.getElementById('tab-title').innerText = item.name
        commit('setLibrary', item)
        break
      }
    }
  }
}
const mutations = {
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
    setToken(userInfo.token)
    setUser(userInfo)
    setUserId(userInfo.id)
  },
  setLibrary (state, library) {
    state.library = library
  },
  removeUserInfo (state) {
    state.userInfo = {}
    clearAuth()
  }
}

export default {
  state,
  actions,
  mutations
}
